import React from 'react'
import PropTypes from 'prop-types'
import { getColor } from 'src/styles'
import { mergeProps } from 'src/util'
import styles from './Badge.scss'

/**
 * Circle badge to display numbers.
 */
const Badge = ({ style, size, position, color, inline, visible, children, border, content, ...domProps }) => (
  <div style={{ fontSize: size, ...style }} className={styles.container}>
    {children}
    <div
      {...mergeProps()(
        {
          className: [styles.badge, { [styles.inline]: inline, [styles.hidden]: !visible }],
          style: {
            width: size,
            height: size,

            boxShadow: border && `0 0 0 .2rem ${getColor(border)}`,
            ...position,
            position: !inline ? 'absolute' : 'initial',
            backgroundColor: getColor(color),
          },
        },
        domProps
      )}
    >
      {content}
    </div>
  </div>
)

Badge.defaultProps = {
  size: '.85rem',
  position: { top: '-0.25rem', right: '-0.25rem' },
  color: 'primary',
  inline: false,
  visible: true,
}

Badge.propTypes = {
  /**
   * A function to render badge content
   */
  content: PropTypes.node,
  /**
   * style to apply to the root element
   */
  style: PropTypes.object,
  /**
   * A size to apply to the badge.
   */
  size: PropTypes.string,
  /**
   * The position of the badge.
   */
  position: PropTypes.shape({
    top: PropTypes.string,
    right: PropTypes.string,
    bottom: PropTypes.string,
    left: PropTypes.string,
  }),
  /**
   * The background color of the badge.
   */
  color: PropTypes.string,
  /**
   * The color of the border if any.
   */
  border: PropTypes.string,
  /**
   * Whether the badge is to be displayed inline, or with an absolute position
   */
  inline: PropTypes.bool,
  /**
   * Whether the badge is visible or not
   */
  visible: PropTypes.bool,
  /**
   * The element on which the badge will appear.
   */
  children: PropTypes.node,
}

export default Badge
